import type React from "react";

export type StatusVariant = "success" | "info" | "warning" | "error" | "neutral";

// Badges keep the same strong, mode-independent colors in light and dark (like
// the snackbar variants), with text colors pinned for contrast. One canonical
// status control reused across orders, users and opportunities (#55072).
const VARIANT_CLASSES: Record<StatusVariant, string> = {
    success: "bg-[#47962D] text-white",
    info: "bg-[#48BD9C] text-[#0E1529]",
    warning: "bg-[#FDCD43] text-[#0E1529]",
    error: "bg-[#BD4769] text-white",
    neutral: "bg-[#6B7280] text-white",
};

interface StatusBadgeProps {
    variant: StatusVariant;
    label: string;
    className?: string;
    /** optional leading icon, sized by the badge text */
    icon?: React.ReactNode;
}

const StatusBadge = ({variant, label, className, icon}: StatusBadgeProps) => (
    <span
        className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium leading-none whitespace-nowrap ${VARIANT_CLASSES[variant]} ${className ?? ""}`}
    >
        {/* The theme enlarges icons to 1.75em; pin a smaller size and let it overlap the
            padding so a badge with icon is as tall as one without. */}
        {icon && <span className="inline-flex -my-1 [&_.MuiSvgIcon-root]:text-[1.25em]">{icon}</span>}
        {label}
    </span>
);

export default StatusBadge;
